import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import SidePanel from './Panels/SidePanel';
import {
  DEFAULT_SIDEPANEL_WIDTH,
  MAX_SIDEPANEL_WIDTH,
  MIN_SIDEPANEL_WIDTH
} from 'utils/appConstants';
import Footer from './Footer';

const StyledPanels = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  overflow-y: auto;
  height: 100%;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: auto;
`;

const StyledSidePanel = styled.div`
  height: 100%;
  display: ${({ displaySidePanel }) => (displaySidePanel ? 'block' : 'none')};
  width: ${({ sidePanelWidth }) => sidePanelWidth}px;
  background: white;
  z-index: 3;
  overflow-y: auto;
`;

const Resizer = styled.div`
  height: 100%;
  width: 4px;
  background-color: #ddd;

  :hover {
    cursor: ew-resize;
  }
`;

const Panels = ({ children }) => {
  const displaySidePanels = useSelector(
    state => state.sidePanel.displaySidePanel
  );
  const [displaySidePanel, setDisplaySidePanel] = useState(false);
  const [sidePanelIsResizing, setSidePanelIsResizing] = useState(false);
  const [sidePanelWidth, setSidePanelWidth] = useState(DEFAULT_SIDEPANEL_WIDTH);

  const updateSidePanelWidth = useCallback(
    e => {
      e.preventDefault();
      if (sidePanelIsResizing) {
        const offset = window.innerWidth - e.pageX;
        if (offset <= MAX_SIDEPANEL_WIDTH && offset >= MIN_SIDEPANEL_WIDTH) {
          setSidePanelWidth(offset);
        }
      }
    },
    [sidePanelIsResizing]
  );

  const handleButtonRelease = useCallback(
    e => {
      if (sidePanelIsResizing) {
        setSidePanelIsResizing(false);
      }
    },
    [sidePanelIsResizing]
  );

  useEffect(() => {
    window.addEventListener('mouseup', handleButtonRelease);
    return () => {
      window.removeEventListener('mouseup', handleButtonRelease);
    };
  }, [handleButtonRelease]);

  useEffect(() => {
    window.addEventListener('mousemove', updateSidePanelWidth);
    return () => {
      window.removeEventListener('mousemove', updateSidePanelWidth);
    };
  }, [updateSidePanelWidth]);

  useEffect(() => {
    if (displaySidePanel !== displaySidePanels) {
      setDisplaySidePanel(displaySidePanels);
    }
  }, [displaySidePanel, displaySidePanels]);

  const handleButtonPress = e => {
    e.preventDefault();
    setSidePanelIsResizing(true);
  };

  return (
    <StyledPanels>
      <LeftPanel>
        {children}
        <Footer />
      </LeftPanel>
      {displaySidePanel && (
        <Resizer
          onMouseDown={handleButtonPress}
          onMouseUp={handleButtonRelease}
        />
      )}
      <StyledSidePanel
        displaySidePanel={displaySidePanel}
        sidePanelWidth={sidePanelWidth}
      >
        <SidePanel />
      </StyledSidePanel>
    </StyledPanels>
  );
};

export default Panels;
